





























































import { Component, Prop, Emit, Watch } from 'vue-property-decorator';
import Vue from 'vue';

@Component
export default class UiMenuContent extends Vue {
  @Prop({default: () => [] as Bemob.ListItem[]})
  items: Bemob.ListItem[];

  @Prop()
  submenu: boolean;

  @Prop()
  filter: boolean;

  @Prop()
  menuProps: any;

  @Prop()
  selected: string;

  @Emit('action') 
  onAction(item: Bemob.ListItem) {}

  filterValue: string = '';

  get pItems() {
    return this.items.map((item) => {
      const title = item.title 
        ? item.title.toLowerCase()
        : '';

      const subtitle = item.subtitle 
        ? item.subtitle.toLowerCase()
        : '';

      return `${title} ${subtitle}`;
    });
  }

  get selectedMenuItem() {
    return this.selected || this.menuProps?.selected
  }

  get itemsFiltered() {
    if(this.filter && this.filterValue) {
      const filterValue = this.filterValue.toLowerCase();
      return this.items.filter((item, index) => this.pItems[index].includes(filterValue));  
    }

    return this.items;
  }

  getDefaultMenuProps() {
    return {
      menuWidth: 0
    };
  }

  get pMenuProps() {
    const menuProps: any = this.menuProps || {};
    return {
      ...this.getDefaultMenuProps(),
      ...menuProps
    }
  } 

  clear() {
    this.filterValue = '';
  }

  handleAction(item: Bemob.ListItem) {
    this.onAction(item);
  }
}
